import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddOffer from "./addOffer";
import {
  useDeleteOfferMutation,
  useUpdateOfferMutation,
  useGetOffersQuery,
  useAddOffersMutation,
} from "slices/common/offerSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";

function Offers() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteOfferMutation();
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [add] = useAddOffersMutation();
  const [updateOffer] = useUpdateOfferMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, isLoading, refetch } = useGetOffersQuery({
    page,
    limit,
    search,
  });
  const col = [
    { display: "Title", key: "title", type: "display" },
    {
      display: "Type",
      key: "cat",
      type: "display", // optional if you want to distinguish types
      render: (row) => (
        <>{row.category_type === "Shop_Categories" ? "E-Commerce" : "Beauty"}</>
      ),
    },
    {
      display: "Category",
      key: "cat",
      type: "display", // optional if you want to distinguish types
      render: (row) => <>{row.category?.name || "-"}</>,
    },
    {
      display: "Sub-Category",
      key: "cat",
      type: "display", // optional if you want to distinguish types
      render: (row) => <>{row.subCategory?.name || "-"}</>,
    },
  ];

  const canEdit = hasActionAccess(auth, "Settings", "Offers", "edit");
  const canDelete = hasActionAccess(auth, "Settings", "Offers", "delete");

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this offer?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const handleSubmit = async (data) => {
    console.log("dtaaaaaa", data);
    try {
      if (editing) {
        await updateOffer({ id: editing._id, body: data }).unwrap();
        refetch();
      } else {
        await add(data).unwrap();
        refetch();
      }
      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null); // <-- Clear editing data
  };

  const canAdd = hasActionAccess(auth, "Settings", "Offers", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddOffer
        open={open}
        onClose={handleClose}
        initialData={editing}
        onSubmit={handleSubmit}
      />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Offer
        </Button>
      )}

      <Tables
        title={"Offers"}
        handleSearch={handleSearchChange}
        totalPages={data?.page}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Offers;
